import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/ClassifierTree/EditorTree/fetchChildren.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import * as api from '@gmini/sm-api-sdk';
import { DEFAULT_FETCH_LIMIT } from "../../Common";
export function fetchChildren(_ref) {
  var currentClassifierData = _ref.currentClassifierData,
      _node = _ref.node,
      offset = _ref.offset,
      dynamicMode = _ref.dynamicMode,
      byNodeIds = _ref.byNodeIds,
      _ref$key = _ref.key,
      key = _ref$key === void 0 ? "".concat(_node.id) : _ref$key;
  var node = _node.type === 'ReferenceNode' ? _node.element : _node;
  var fromTo = {
    limit: DEFAULT_FETCH_LIMIT,
    offset: offset || 0
  };

  switch (node.type) {
    case 'UserClassifierNode':
      {
        api.UserClassifier.fetch.defaultContext.submit(node);
        break;
      }

    case 'UserClassifierGroupNode':
      {
        if (!currentClassifierData) {
          return;
        }

        if ((node.groupType === 'WithElements' || node.groupType === 'WithGroups') && node.total !== node.children.length) {
          api.UserClassifierGroup.fetch.defaultContext.submit(_objectSpread({
            classifierId: currentClassifierData.id,
            parentClassifierVersion: currentClassifierData.version,
            id: node.id
          }, fromTo));
        }

        break;
      }

    case 'DynamicGeneratedGroupNode':
      {
        if (!currentClassifierData) {
          return;
        }

        if (!node.children.length || node.children.length && offset && offset > 0) {
          api.DynamicGroup.fetch.defaultContext.submit(_objectSpread({
            classifierId: currentClassifierData.id,
            version: currentClassifierData.version,
            dynamicGroupId: node.id
          }, fromTo));
        }

        break;
      }

    case 'BimStandardSizeNode':
      if (byNodeIds) {
        api.BimElement.fetchByIds.defaultContext.submit(_objectSpread(_objectSpread({}, node), {}, {
          key: key,
          elementIds: byNodeIds
        }));
      } else {
        api.BimStandardSize.Populated.fetch.defaultContext.submit(_objectSpread(_objectSpread(_objectSpread({}, node), fromTo), {}, {
          key: key
        }));
      }

      break;

    default:
  }
}